module.exports = __webpack_public_path__ + "static/mentor-sunil-b0af44756bda005c4367962d3e5e29cf.jpg";